import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
    strict: false,
    plugins: [vuexLocal.plugin],
    state: {
      tab2Id: 0,
      tab4Id:0,
      tab5Id:'all',

    },
    
    getters: {
      tab2Id(state){
        return state.tab2Id
      },
      tab4Id(state){
        return state.tab4Id
      },
      tab5Id(state){
        return state.tab5Id
      },
    },
    mutations: {
      setTabId(state, tab2Id) {
        state.tab2Id = tab2Id;
      },
      setTabId4(state, tab4Id) {
        state.tab4Id = tab4Id;
      },
      setTabId5(state, tab5Id) {
        state.tab5Id = tab5Id;
      }
    },
    actions:{
      changeTab({ commit }, tab2Id) {
        commit('setTabId', tab2Id);
      },
      changeTab4({ commit }, tab4Id) {
        commit('setTabId4', tab4Id);
      },
      changeTab5({ commit }, tab5Id) {
        commit('setTabId5', tab5Id);
      }
    }
})

export default store